module.exports = __webpack_public_path__ + "img/weddings_35_H.0afa3fc9.webp";